import React, { useContext, useState } from "react";
import { Modal } from "antd";
import Input from "../components/shared/input";
import { Select, DatePicker, TimePicker } from "antd";
import Button from "../components/shared/button";
import ReminderSet from "./reminderset";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { createReminder } from "../APIs/remindersApis";
import { AppContext } from "../context/AppContext";

const validationSchema = Yup.object().shape({
  title: Yup.string()
    .required("Title is required")
    .min(3, "Title must be at least 3 characters"),
  description: Yup.string()
    .required("Description is required")
    .min(10, "Description must be at least 10 characters"),
  date: Yup.date().required("Date is required").nullable(),
  time: Yup.date().required("Time is required").nullable(),
  caseType: Yup.string().required("Please select a case type"),
  priority: Yup.string().required("Please select a priority"),
});

const SetReminderModal = ({
  RemModelOpen,
  setRemModelOpen,
  setallReminderModalOpen,
}) => {
  const [remindersetOpen, setremindersetOpen] = useState(false);
  const { Option } = Select;
  const { updateAllReminders } = useContext(AppContext);

  const handleOk = () => {
    setRemModelOpen(false);
  };

  const handleCancel = () => {
    setRemModelOpen(false);
  };
  const SetRemindersClick = () => {
    setremindersetOpen(true);
    setRemModelOpen(false);
  };
  const cases = ["Medical", "Marriage", "Land", "Other"];

  const initialValues = {
    title: "",
    description: "",
    date: null,
    time: null,
    caseType: "",
    priority: "low",
  };

  const handleSubmit = (values, { resetForm }) => {
    createReminder(
      values.title,
      values.description,
      values.date.format("YYYY-MM-DD"),
      values.time.format("HH:mm:ss"),
      values.caseType,
      values.priority
    )
      .then((res) => {
        updateAllReminders();
        setremindersetOpen(true);
        setRemModelOpen(false);
        console.log(res);
        resetForm();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <>
      <Modal
        open={RemModelOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="del-modal"
        centered={true}
        width="35%"
      >
        <div className="modal-content  flex flex-col items-center py-[40px] px-[26px] gap-[32px]">
          <h5 className="text-blue font-manrope text-center font-medium max-w-[327px]">
            What would you like to set a reminder for?
          </h5>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              values,
              errors,
              touched,
              setFieldValue,
              handleBlur,
              handleSubmit,
            }) => (
              <Form
                className="w-full flex flex-col gap-[16px]"
                onSubmit={handleSubmit}
              >
                {/* Title Field */}

                <Input
                  label="Title"
                  type="text"
                  name="text"
                  placeholder="Title"
                  className="dash-input-field"
                  wrapperClass="dash-wrapper"
                  labelClass="dash-label"
                  value={values.title}
                  onChange={(e) => setFieldValue("title", e.target.value)}
                  onBlur={handleBlur}
                />
                {touched.title && errors.title && (
                  <div className="text-red-500 text-sm">{errors.title}</div>
                )}

                {/* Description Field */}

                <Input
                  label="Description"
                  type="text"
                  name="text"
                  placeholder="Description"
                  className="dash-input-field"
                  wrapperClass="dash-wrapper"
                  labelClass="dash-label"
                  value={values.description}
                  onChange={(e) => setFieldValue("description", e.target.value)}
                  onBlur={handleBlur}
                />
                {touched.description && errors.description && (
                  <div className="text-red-500 text-sm">
                    {errors.description}
                  </div>
                )}

                {/* Date Picker */}
                <div>
                  <p className="text-blue font-medium font-manrope medium">
                    Date
                  </p>
                  <DatePicker
                    className="w-full mt-[6px]"
                    name="date"
                    // value={values.date ? moment(values.date) : null}
                    onChange={(date) => setFieldValue("date", date)}
                    onBlur={handleBlur}
                    disabledDate={(current) =>
                      current && current < moment().startOf("day")
                    }
                  />
                  {touched.date && errors.date && (
                    <div className="text-red-500 text-sm">{errors.date}</div>
                  )}
                  {/* <DatePicker className="w-full mt-[6px]" /> */}
                </div>

                {/* Time Picker */}
                <div>
                  <p className="text-blue font-medium font-manrope medium">
                    Time
                  </p> 
                  <TimePicker
                    use12Hours
                    className="w-full mt-[6px]"
                    // value={values.time ? moment(values.time) : null}
                    onChange={(time) => setFieldValue("time", time)} 
                    onOk={(time) => setFieldValue("time", time)}
                    onBlur={handleBlur} 
                  />
                  {touched.time && errors.time && (
                    <div className="text-red-500 text-sm">{errors.time}</div>
                  )}
                  {/* <TimePicker className="w-full mt-[6px]" /> */}
                </div>

                {/* Select Dropdown */}
                <div className="select-case-drop">
                  <p className="text-blue font-medium font-manrope medium">
                    Select Case
                  </p>
                  <Select
                    placeholder="Medical"
                    className="reminder-case w-full mt-[6px] rounded-[10px] bg-white border-none"
                    value={values.caseType}
                    onChange={(value) => setFieldValue("caseType", value)}
                    onBlur={handleBlur}
                  >
                    {cases.map((caseOption, index) => (
                      <Option key={index} value={caseOption}>
                        {caseOption}
                      </Option>
                    ))}
                  </Select>
                  {touched.caseType && errors.caseType && (
                    <div className="text-red-500 text-sm">
                      {errors.caseType}
                    </div>
                  )}
                </div>

                {/* prirority drowdown */}
                <div className="select-case-drop">
                  <p className="text-blue font-medium font-manrope medium">
                    Priority
                  </p>
                  <Select
                    placeholder="Low"
                    className="reminder-case w-full mt-[6px] rounded-[10px] bg-white border-none"
                    value={values.priority}
                    onChange={(value) => setFieldValue("priority", value)}
                    onBlur={handleBlur}
                  >
                    <Option value="low">Low</Option>
                    <Option value="medium">Medium</Option>
                    <Option value="high">High</Option>
                  </Select>
                  {touched.priority && errors.priority && (
                    <div className="text-red-500 text-sm">
                      {errors.priority}
                    </div>
                  )}
                </div>

                <Button
                  text="Set Reminder"
                  className="button btn-blue !rounded-[39px] large mt-[45px] m-auto"
                  height={45}
                  width={176}
                  // htmlType="submit"
                  type="submit"
                />
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
      <ReminderSet
        remindersetOpen={remindersetOpen}
        setremindersetOpen={setremindersetOpen}
        setallReminderModalOpen={setallReminderModalOpen}
      />
    </>
  );
};

export default SetReminderModal;
